<ng-container *ngIf="contentlet$ | async as contentlet">
  <div
    *ngIf="contentlet.url"
    class="video-container default-video-class youtube-video"
    [ngClass]="getVideoClasses(contentlet)"
  >
    <div
      [ngClass]="(getVideoHeight$(contentlet) | async) ? 'video-wrapper custom-video-wrapper' : 'video-wrapper'"
      [ngStyle]="{ 'height.px': (getVideoHeight$(contentlet) | async) }"
    >
      <!-- spell-checker: words allowfullscreen -->
      <ng-container *ngIf="iframeVideoUrl(contentlet) as url">
        <iframe
          [title]="contentlet?.title"
          [src]="url"
          frameborder="0"
          allow="accelerometer; autoplay *; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </ng-container>
    </div>
  </div>
</ng-container>
